import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';

@Component({
    selector: 'file-cell',
    template: `<span><i class="fa fa-paperclip" (click)="invokeParentMethod();" style="width:100%;"></i></span>`,
    styles: [
        `.btn {
      line-height: 0.5
    }`
    ]
})

export class FileChildRendered implements ICellRendererAngularComp {
    public params: any;

    agInit(params: any): void {
        this.params = params;
    }

    public invokeParentMethod() {
        this.params.context.files(this.params);
    }

    refresh(): boolean {
        return false;
    }
}
